module.exports = __webpack_public_path__ + "media/beep.32ffaec3.mp3";